/**
 * Hook returning the current tenant context value.
 */

import { useContext } from 'react';
import { TenantContext } from './tenantContextInstance';

export const useTenant = () => {
  const context = useContext(TenantContext);

  if (context === undefined) {
    throw new Error('useTenant must be used within a TenantProvider');
  }

  return context;
};
